'use client';
import { composeHoc } from '../../../utils/compose';
import { withSingleBenchmark } from './single';
import { Benchmark as MultipleSelectBenchmark } from './multiple';
import { IBenchmarkProps } from './interface';

export const Benchmark: React.FC<IBenchmarkProps> = composeHoc(
  withSingleBenchmark
)(MultipleSelectBenchmark);

export * from './benchmark-color';
